// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2DRHk","footer":"ModalCreateQualiphyProcedure_footer__3oMUl","additionData":"ModalCreateQualiphyProcedure_additionData__1I8qU"};